export default __webpack_public_path__ + "static/letter-934797f04f10a6b7855d0102c52c6387.jpg";